<!-- <div [id]="idName" style="width: 100%; height: 100%;"></div> -->
<div class=" p-4">
  <!-- <div class="flex justify-between items-center mb-2 btnFilter">
        <h2>data</h2>
        <h3>New Projects Trend</h3>
        <div>
            <select [(ngModel)]="selectedFilter" (change)="onFilterChange()" class="border rounded p-1">
                <option value="Yearly">Yearly</option>
                <option value="Monthly">Monthly</option>
                <option value="Weekly">Weekly</option>
            </select>

            <span class="cursor-pointer ml-3" (click)="resetZoom()">
                <i class="fas fa-sync-alt"></i> 
            </span>
        </div>
    </div> -->
  <!-- <div class="flex justify-between items-center mb-4">
  <h2 class="text-lg font-semibold">Data</h2>

  <div class="flex items-center space-x-3">
    <select [(ngModel)]="selectedFilter" 
            (change)="onFilterChange()" 
            class="border rounded px-2 py-1 text-sm focus:outline-none">
      <option value="Yearly">Yearly</option>
      <option value="Monthly">Monthly</option>
      <option value="Weekly">Weekly</option>
    </select>

    <button (click)="resetZoom()" 
            class="p-2 rounded-full hover:bg-gray-200 transition flex items-center justify-center">
      <i class="fas fa-sync-alt text-gray-600"></i>
    </button>
  </div>
</div> -->




  <div class="row align-items-center">
    <div class="col-sm-6 headingCol">
      <h5 class="text-lg font-semibold"> {{chartTitleName}} ({{selectedFilter | titlecase}})</h5>
    </div>
    <div class="col-sm-6 text-right headingCol">
      <select [(ngModel)]="selectedFilter" (change)="onFilterChange()"
        class="border rounded px-2 py-1 text-sm focus:outline-none">
        <option value="yearly">Yearly</option>
        <option value="monthly">Monthly</option>
        <option value="weekly">Weekly</option>
      </select>
      <button (click)="resetZoom()" class="ml-1 reset-btn">
        <i class="fas fa-sync-alt text-gray-600"></i>
      </button>
    </div>
  </div>

  <div *ngIf="chartOptions?.series && chartOptions.series.length > 0">
    <apx-chart #chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
      [stroke]="chartOptions.stroke" [title]="chartOptions.title" [yaxis]="chartOptions.yaxis"
      [fill]="chartOptions.fill" [dataLabels]="chartOptions.dataLabels"></apx-chart>
  </div>
  <div *ngIf="!chartOptions?.series || chartOptions.series.length === 0">
    <p class="text-center text-gray-500">Loading chart...</p>
  </div>
</div>